module.exports = __webpack_public_path__ + "img/app3.4d180a18.png";